<template>
  <div>
    <v-flex xs12 sm8 offset-sm2>
      <h2 class="text-center mb-3">Rom</h2>
    </v-flex>
    <v-container>
      <v-layout row wrap align-content-center>
        <template v-for="(item, index) in stepValues.roomList">
          <v-flex xs12 sm6 md4 lg3 :key="index" class="mb-2 p-2">
            <Room
              :room="item"
              :index="index"
              @delete-room="deleteRoom"
              @edit-room="editRoom"
              :key="index"
            ></Room>
          </v-flex>
        </template>
      </v-layout>
    </v-container>
    <v-flex xs12 class="mb-5">
      <v-btn block color="success" :dark="protocol.dark" v-on:click.stop="openEditRoomDialog">Legg til nytt rom</v-btn>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" />
    <EditRoom
      :dialog="editRoomDialog"
      @update-fields="updateFields"
      :selectedRoom="selectedRoom"
      @close-edit-room-dialog="closeEditRoomDialog"
      :protocol="protocol"
    ></EditRoom>
  </div>
</template>

<script>
import Room from "../Rooms/Room.vue";
import EditRoom from "./EditRoom.vue";
import RoomObject from "../../../models/room";
import step from "../../../mixins/step";
export default {
  mixins: [step],
  data() {
    return {
      editRoomDialog: false,
      selectedRoom: new RoomObject("Bedroom")
    };
  },
  components: { Room, EditRoom },
  beforeMount: function() {
    if (this.stepValues.roomList.length === 0) {
      let defaultRooms = [];
      if (this.protocol.saved_values.steps['inspection-basics']) {
        defaultRooms = this.protocol.saved_values.steps['inspection-basics'].saved_values.houseType.defaultRooms;
      }
      this.stepValues.roomList = defaultRooms
    }
  },
  methods: {
    deleteRoom: function(i) {
      this.stepValues.roomList.splice(i, 1);
      this.updateFields();
    },
    editRoom: function(room) {
      this.selectedRoom = room;
      this.selectedRoom.edited = true;
      this.editRoomDialog = true;
    },
    openEditRoomDialog: function() {
      this.selectedRoom = null;
      let newRoom = new RoomObject("Bedroom");
      this.stepValues.roomList.push(newRoom);
      this.selectedRoom = newRoom;
      this.updateFields();
      this.editRoomDialog = true;
    },
    closeEditRoomDialog: function() {
      this.selectedRoom.edited = true;
      this.updateFields();
      this.editRoomDialog = false;
    }
  }
};
</script>

